export enum AddClientDrawerStep {
    SetupMethod = "setupMethod",
    SelectLedger = "selectLedger",
    HistoricalData = "historicalData",
    ClientDetails = "clientDetails",
    MultiEntity = "multiEntity",
    SelectPlan = "selectPlan",
    Invite = "invite",
    AddAnotherEntity = "addAnotherEntity",
    Result = "result",
}

interface DrawerStepConfig {
    id: AddClientDrawerStep;
    label: string;
    hideInStepper?: boolean;
}

export const DRAWER_STEP_CONFIG: DrawerStepConfig[] = [
    { id: AddClientDrawerStep.SetupMethod, label: "Chart of Accounts" },
    { id: AddClientDrawerStep.SelectLedger, label: "Ledgers" },
    { id: AddClientDrawerStep.HistoricalData, label: "Historical data" },
    { id: AddClientDrawerStep.ClientDetails, label: "Client details" },
    {
        id: AddClientDrawerStep.MultiEntity,
        label: "Multi-entity",
        hideInStepper: true,
    },
    { id: AddClientDrawerStep.SelectPlan, label: "Plan" },
    { id: AddClientDrawerStep.Invite, label: "Invite client" },
    {
        id: AddClientDrawerStep.AddAnotherEntity,
        label: "Add another entity",
        hideInStepper: true,
    },
    { id: AddClientDrawerStep.Result, label: "Done" },
];
